<div class="ha-work-life-section section-wrapper">
	<div id="lifestyle-work-life-balance">
		<div class="heading">
			<span [translate]="'wellness.health-assessment-new.lifestyle.work-life.heading'">Safety</span>
		</div>
		<div class="form-group" [formGroup]="workLifeForm">
			<div class="form-field slider-group-with-label">
				<div
					class="radio-btn-label"
					[translate]="'wellness.health-assessment-new.lifestyle.work-life.form-fields.hours-you-work'">
					How many hours do you work in an average week?
				</div>
				<div class="slider-show-value-text h-70" *ngIf="workLifeData">
					<div class="slider-labels">
						<span class="label-value-text">
							{{ getHoursSpentWorking(workLifeForm.get('hoursSpentWorking').value) }}
						</span>
					</div>
					<mat-slider
						appAutofocus
						class="example-margin"
						[disabled]="readOnly"
						[max]="workingHoursSlider.max"
						[min]="workingHoursSlider.min"
						[step]="workingHoursSlider.step"
						[showTickMarks]="workingHoursSlider.showTickMarks">
						<input matSliderThumb formControlName="hoursSpentWorking" [(ngModel)]="workLifeData.hoursSpentWorking" />
					</mat-slider>
				</div>
			</div>
			<div class="form-field">
				<div
					class="radio-btn-label"
					[translate]="'wellness.health-assessment-new.lifestyle.work-life.form-fields.get-enough-time-with-family'">
					Do you have difficulty sleeping?
				</div>
				<mat-radio-group formControlName="spendTimeWithFamily" [disabled]="readOnly">
					<mat-radio-button [value]="true">
						<span [translate]="'wellness.health-assessment-new.lifestyle.work-life.form-fields.option-yes'">Yes</span>
					</mat-radio-button>
					<mat-radio-button [value]="false">
						<span [translate]="'wellness.health-assessment-new.lifestyle.work-life.form-fields.option-no'">No</span>
					</mat-radio-button>
				</mat-radio-group>
			</div>
			<div class="form-field slider-group-with-label" *ngIf="workLifeData">
				<div
					class="radio-btn-label"
					[translate]="'wellness.health-assessment-new.lifestyle.work-life.form-fields.nights-away-from-home'">
					How often are you away from home for business (nights away from home per month)?
				</div>
				<div class="slider-show-value-text">
					<div class="slider-labels">
						<span class="label-value-text">
							{{ getNightsAwayFromHome(workLifeForm.get('nightsAwayFromHome').value) }}
						</span>
					</div>
					<mat-slider
						class="example-margin"
						[disabled]="readOnly"
						[max]="nightsAwayFromHomeSlider.max"
						[min]="nightsAwayFromHomeSlider.min"
						[step]="nightsAwayFromHomeSlider.step"
						[showTickMarks]="nightsAwayFromHomeSlider.showTickMarks">
						<input matSliderThumb formControlName="nightsAwayFromHome" [(ngModel)]="workLifeData.nightsAwayFromHome" />
					</mat-slider>
				</div>
			</div>
			<div class="question-wrapper">
				<div
					class="radio-btn-label"
					[translate]="
						'wellness.health-assessment-new.lifestyle.work-life.form-fields.hoursMissedFromWorkHealthProblems'
					">
					During the past 7 days, how many hours did you miss from work because of your health problems? Include hours
					you missed on sick days, times you went in late, left early, etc., because of your health problems.
				</div>
				<mat-radio-group formControlName="hoursMissedFromWorkHealthProblems" [disabled]="readOnly">
					<mat-radio-button [value]="condition.id" *ngFor="let condition of hoursMissedFromWorkLookup">
						<span>{{ condition.name }}</span>
					</mat-radio-button>
				</mat-radio-group>
			</div>
			<div class="question-wrapper">
				<div
					class="radio-btn-label"
					[translate]="'wellness.health-assessment-new.lifestyle.work-life.form-fields.hoursMissedFromWorkOtherReason'">
					During the past 7 days, how many hours did you miss from work because of any other reason, such as vacation,
					holidays?
				</div>
				<mat-radio-group formControlName="hoursMissedFromWorkOtherReason" [disabled]="readOnly">
					<mat-radio-button [value]="condition.id" *ngFor="let condition of hoursMissedFromWorkLookup">
						<span>{{ condition.name }}</span>
					</mat-radio-button>
				</mat-radio-group>
			</div>
			<div class="question-wrapper">
				<div
					class="radio-btn-label"
					[translate]="
						'wellness.health-assessment-new.lifestyle.work-life.form-fields.healthProblemsAffectProductivity'
					">
					During the past 7 days, how much did health problems affect your productivity while you were working?
				</div>
				<mat-radio-group formControlName="healthProblemsAffectProductivity" [disabled]="readOnly">
					<mat-radio-button [value]="condition.id" *ngFor="let condition of healthProblemAbilityAffectLookup">
						<span>{{ condition.name }}</span>
					</mat-radio-button>
				</mat-radio-group>
			</div>
			<div class="question-wrapper">
				<div
					class="radio-btn-label"
					[translate]="'wellness.health-assessment-new.lifestyle.work-life.form-fields.healthProblemsAffectAbility'">
					During the past 7 days, how much did health problems affect your ability to do your regular daily activities,
					other than work at a job?
				</div>
				<mat-radio-group formControlName="healthProblemsAffectAbility" [disabled]="readOnly">
					<mat-radio-button [value]="condition.id" *ngFor="let condition of healthProblemAbilityAffectLookup">
						<span>{{ condition.name }}</span>
					</mat-radio-button>
				</mat-radio-group>
			</div>
			<div class="form-field">
				<div
					class="radio-btn-label"
					[translate]="'wellness.health-assessment-new.lifestyle.work-life.form-fields.no-of-children'">
					How many children do you have?
				</div>
				<mat-form-field appearance="fill">
					<input matInput formControlName="numberOfChildren" [readonly]="readOnly" />
				</mat-form-field>
			</div>
			<div class="form-field">
				<div
					class="radio-btn-label"
					[translate]="'wellness.health-assessment-new.lifestyle.work-life.form-fields.no-of-children-living-with-you'">
					How many children are living with you at home?
				</div>
				<mat-form-field appearance="fill">
					<input matInput formControlName="numberOfChildrenLivingWithYou" [readonly]="readOnly" />
				</mat-form-field>
			</div>
		</div>
	</div>
</div>
<div *ngIf="!readOnly" class="save-btn {{ readOnly ? 'read-only' : '' }}" (click)="saveWorkLifeData()">
	<button class="button button-medium" mat-button>
		<span *ngIf="returningUser" [translate]="'wellness.health-assessment-new.update-button'">Update</span>
		<span *ngIf="!returningUser" [translate]="'wellness.health-assessment-new.next-button'">Next</span>
	</button>
</div>
